/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeListInner } from './ChallengeListInner';
import {
    ChallengeListInnerFromJSON,
    ChallengeListInnerFromJSONTyped,
    ChallengeListInnerToJSON,
} from './ChallengeListInner';
import type { TokenV2ReponseType } from './TokenV2ReponseType';
import {
    TokenV2ReponseTypeFromJSON,
    TokenV2ReponseTypeFromJSONTyped,
    TokenV2ReponseTypeToJSON,
} from './TokenV2ReponseType';

/**
 * 
 * @export
 * @interface TokenV2ResponseChallengeList
 */
export interface TokenV2ResponseChallengeList {
    /**
     * 
     * @type {TokenV2ReponseType}
     * @memberof TokenV2ResponseChallengeList
     */
    type: TokenV2ReponseType;
    /**
     * 
     * @type {Array<ChallengeListInner>}
     * @memberof TokenV2ResponseChallengeList
     */
    challenges: Array<ChallengeListInner>;
}

/**
 * Check if a given object implements the TokenV2ResponseChallengeList interface.
 */
export function instanceOfTokenV2ResponseChallengeList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "challenges" in value;

    return isInstance;
}

export function TokenV2ResponseChallengeListFromJSON(json: any): TokenV2ResponseChallengeList {
    return TokenV2ResponseChallengeListFromJSONTyped(json, false);
}

export function TokenV2ResponseChallengeListFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenV2ResponseChallengeList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': TokenV2ReponseTypeFromJSON(json['type']),
        'challenges': ((json['challenges'] as Array<any>).map(ChallengeListInnerFromJSON)),
    };
}

export function TokenV2ResponseChallengeListToJSON(value?: TokenV2ResponseChallengeList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': TokenV2ReponseTypeToJSON(value.type),
        'challenges': ((value.challenges as Array<any>).map(ChallengeListInnerToJSON)),
    };
}

